/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Searchforprospects3Inputs */

const en_coinvestments_searchforprospects3 = /** @type {(inputs: Coinvestments_Searchforprospects3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search for prospects`)
};

/**
* | output |
* | --- |
* | "Search for prospects" |
*
* @param {Coinvestments_Searchforprospects3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_searchforprospects3 = /** @type {((inputs?: Coinvestments_Searchforprospects3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Searchforprospects3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_searchforprospects3(inputs)
});
export { coinvestments_searchforprospects3 as "coInvestments_searchForProspects" }